import type { ReactNode } from 'react';

/**
 * A simple toolbar for DataGrid subtables.
 * Should only display a title and an optional icon.
 * For more complex toolbars with filters, toggles, or other controls,
 * use the full-featured SubtableToolbar from subtable-toolbar.tsx instead.
 */

export type SimpleSubtableToolbarProps = {
	title: string;
	icon?: ReactNode;
};

export function SimpleSubtableToolbar({ title, icon }: SimpleSubtableToolbarProps) {
	return (
		<div className='flex items-center justify-between border-b border-gray-a4 px-3 py-2'>
			<div className='flex items-center gap-1.5'>
				<span className='text-md font-semibold'>{title}</span>
				{icon}
			</div>
		</div>
	);
}

declare module '@mui/x-data-grid-premium' {
	interface ToolbarPropsOverrides extends SimpleSubtableToolbarProps {}
}

